import axios from 'axios';

function getTemplates() {
    const route = '/cost-estimates/templates';
    return axios.get(route);
}

function saveAsTemplates(id) {
    const route = '/cost-estimates/{id}/saveAsTemplate';
    return axios.post(route.replace('{id}', id));
}

function createNewFromTemplate(id) {
    const route = '/cost-estimates/{id}/createFromTemplate';
    return axios.post(route.replace('{id}', id));
}

function fetchCustomerInfoFromArticles(id) {
    const route = '/cost-estimates/{id}/fetchCustomerInfoFromArticles';
    return axios.get(route.replace('{id}', id));
}

function fetchProductionInfoFromArticles(id) {
    const route = '/cost-estimates/{id}/fetchProductionInfoFromArticles';
    return axios.get(route.replace('{id}', id));
}

export default {
    createNewFromTemplate,
    getTemplates,
    saveAsTemplates,
    fetchCustomerInfoFromArticles,
    fetchProductionInfoFromArticles
}
